module.exports = __webpack_public_path__ + "static/mammut-50b4a54ea961739e850ea9a7a1ca6b2f.jpg";